import { render } from "./Telegram.vue?vue&type=template&id=06738691&scoped=true"
import script from "./Telegram.vue?vue&type=script&lang=js"
export * from "./Telegram.vue?vue&type=script&lang=js"

import "./Telegram.vue?vue&type=style&index=0&id=06738691&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06738691"]])

export default __exports__